import * as React from 'react';
import { translate } from 'components/translate-hoc';
import { ITranslationProps } from 'types/translation';
import { IStepsDescriptionRewardProps } from './steps-description.types';
import TEXT_KEYS, { STEPS_AMOUNT } from './step-description.constants';
import StepsDescriptionStep from './steps-description-step';
import StepsDescriptionReward from './steps-description-reward';
import './steps-description.styles.less';

type Props = ITranslationProps & IStepsDescriptionRewardProps;

export const STEPS_DESCRIPTION_ANCHOR_ID = 'steps-description';

const StepsDescription: React.FC<Props> = ({
    dangerouslyTranslateWithHTML: translateKey,
    imageSrc,
    showRewardsImageLightbox,
    isLightboxOpen
}) => {
    const steps: JSX.Element[] = [];

    for (let i = 1; i <= STEPS_AMOUNT; ++i) {
        const title = translateKey(TEXT_KEYS[`STEP_${i}_TITLE`]);
        const text = translateKey(TEXT_KEYS[`STEP_${i}_TEXT`]);
        steps.push(
            <StepsDescriptionStep
                key={ i }
                index={ i }
                title={ title }
                text={ text }
            />
        );
    }

    return (
        <div className="sitegen-fr-steps-description">
            <div className="sitegen-fr-steps-description__inner">
                <div className="sitegen-fr-steps-description__scroll-anchor" id={STEPS_DESCRIPTION_ANCHOR_ID}></div>
                <div className="sitegen-fr-steps-description__title">
                    { translateKey(TEXT_KEYS.TITLE) }
                </div>
                <div className="sitegen-fr-steps-description__steps">
                    <div className="sitegen-fr-steps-description__text">
                        { steps }
                    </div>
                    <div className="sitegen-fr-steps-description__image">
                        <StepsDescriptionReward
                            imageSrc={ imageSrc }
                            showRewardsImageLightbox={ showRewardsImageLightbox }
                            isLightboxOpen={isLightboxOpen}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default translate()(StepsDescription);
